module.exports = __webpack_public_path__ + "img/18.f10baf30.png";